/* eslint-disable import/no-unresolved */
import { LitElement, html } from 'lit-all'
/* eslint-disable import/no-unresolved */

/**
 * This should be used as a base class for all LitElement components.
 * It will allow us to use Tailwind within the shadow DOM.
 * Taken from Project Syrah: https://github.com/meetdomaine/project-syrah/blob/main/src/base/BaseElement.ts#L8C5-L8C52
 */

// Cache global stylesheets
let globalSheets = []
const IGNORED_DOMAINES = [
  'fonts.googleapis.com',
  'section-open-html-blocks',
  'instafeed.nfcube.com',
]
// TODO: Temporarily adding tailwind-output.css to the whitelist. Once we have more fully integrated Tailwind, we can remove this.
const WHITELISTED_SHEETS = ['tailwind-output.css']
export function getGlobalStyleSheets() {
  if (globalSheets.length === 0) {
    globalSheets = Array.from(document.styleSheets)
      .map((x) => {
        if (
          x.href &&
          (IGNORED_DOMAINES.some((d) => x.href.includes(d)) ||
            !WHITELISTED_SHEETS.some((d) => x.href.includes(d)))
        ) {
          return false
        }

        try {
          const sheet = new CSSStyleSheet()
          const css = Array.from(x.cssRules)
            .map((rule) => rule.cssText)
            .join(' ')
          sheet.replaceSync(css)
          return sheet
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn('Failed to parse CSS rules from stylesheet', x, e)
          return false
        }
      })
      .filter(Boolean)
  }

  return globalSheets
}

export class BaseElement extends LitElement {
  static _hasAdoptedGlobalStyleSheets = false

  constructor() {
    super()
    this.removeAttribute('cloak')
  }

  connectedCallback() {
    super.connectedCallback()
    if (this.shadowRoot && !this._hasAdoptedGlobalStyleSheets) {
      const styleSheets = getGlobalStyleSheets()
      this.shadowRoot.adoptedStyleSheets = [
        ...(this.shadowRoot.adoptedStyleSheets ?? []),
        ...styleSheets,
      ]

      this._hasAdoptedGlobalStyleSheets = true
    }
  }

  $emit(name, detail) {
    return this.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        composed: true,
        detail,
      })
    )
  }

  $listen(name, callback) {
    this.shadowRoot?.addEventListener(name, callback.bind(this))
  }

  $hide() {
    this.style.display = 'none'
  }

  $show() {
    this.style.display = ''
  }

  render() {
    return html`<slot></slot>`
  }
}

export class BaseElementWithoutShadowDOM extends BaseElement {
  static createRenderRoot() {
    return this
  }
}

export default BaseElement
